var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocument = function SvgDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1B216B",
    fillRule: "evenodd",
    clipPath: "url(#a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.455 17.733h31.568l-8.359 19.573H4.096zm1.352 2.048-6.61 15.477h27.115l6.61-15.477z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.017 32.238c0-.566.459-1.024 1.024-1.024h9.927a1.024 1.024 0 1 1 0 2.048h-9.927a1.024 1.024 0 0 1-1.024-1.024M27.968 32.214c0-.565.459-1.024 1.024-1.024h3.94a1.024 1.024 0 1 1 0 2.048h-3.94a1.024 1.024 0 0 1-1.024-1.024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.681 11.33a2.304 2.304 0 0 1 2.304-2.304h9.258c.673 0 1.231.318 1.612.585.287.203.58.46.802.652q.1.09.179.156l.052.044 2.126 2.358h16.778v6.336h-2.048V14.87h-15.64l-2.646-2.933-.224-.195c-.198-.173-.366-.32-.558-.455-.269-.19-.399-.212-.433-.212H5.985a.256.256 0 0 0-.256.256V37.32H3.681z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
};
export { SvgDocument as Icon };
export default __webpack_public_path__ + "static/media/e0043957155b07f89dc030d2b5ebd207.svg";